import * as Animate from "react-reveal";

const steps = [
  {
    number: "01",
    title: "Plug in and begin",
    desc:
      "Access learning content without streaming classes or relying on constant connectivity.",
  },
  {
    number: "02",
    title: "Learn at your pace",
    desc:
      "Move through short video-based classes in a rhythm that works for you.",
  },
  {
    number: "03",
    title: "Practise through projects",
    desc:
      "Use business case-centred activities to connect concepts to real problems.",
  },
  {
    number: "04",
    title: "Build useful skills",
    desc:
      "Explore practical pathways in data, product, design and programming.",
  },
];

const NucleusModelSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4" id="model">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            Offline learning, redesigned
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl lg:text-5xl font-poppins leading-tight font-black max-w-2xl tracking-[-0.03em] text-primary">
              Access should not depend on a perfect connection.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              The Nucleus packages a practical learning experience for people in
              places where connectivity is expensive or unreliable.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step) => (
            <Animate.Fade bottom key={step.number}>
              <article
                className="h-full flex flex-col rounded-2xl p-7 bg-white border border-hire-line"
                style={{ minHeight: "260px" }}
              >
                <span className="text-[#8e5e00] font-poppins text-xs font-extrabold tracking-widest">
                  {step.number}
                </span>
                <h3 className="font-poppins font-bold text-xl text-primary mt-auto mb-3">
                  {step.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                  {step.desc}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NucleusModelSection;
